import { render } from "./LargeText.vue?vue&type=template&id=494429ab"
import script from "./LargeText.vue?vue&type=script&lang=js"
export * from "./LargeText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__